import React from 'react';
import x from '@assets/images/social_icons/x.svg';
import instagram from '@assets/images/social_icons/instagram.svg';
import discord from '@assets/images/social_icons/discord.svg';
import arenas from '@assets/images/social_icons/arena_icon.svg';
import pwa from '@assets/images/pwa.svg';
import pwr from '@assets/images/pwr.png';

const Footer = () => {
  const date = new Date();
  const year = date.getFullYear();

  return (
    <footer>
      <div className='desktop-footer'>
        <div className='footer__social-icons'>
          <a
            href='https://x.com/fundraisinapp'
            target='_blank'
            rel='noreferrer'
          >
            <img
              className='footer__social-icon social-icon2'
              src={x}
              alt='x'
            ></img>
          </a>
          <a
            href='https://arena.social/fundraisinapp'
            target='_blank'
            rel='noreferrer'
          >
            <img
              className='footer__social-icon social-icon4'
              src={arenas}
              alt='arenas'
            ></img>
          </a>
          <a
            href='https://instagram.com/fundraisin.app'
            target='_blank'
            rel='noreferrer'
          >
            <img
              className='footer__social-icon social-icon4'
              src={instagram}
              alt='instagram'
            ></img>
          </a>
          <span className='footer-vertical-line'></span>
          <a
            href='/tos'
            target='_blank'
            rel='noreferrer'
            className='footer-tos-text'
          >
            Terms of Service
          </a>
        </div>
        <div className='footer__copyright'>
          <span className='footer__copyright-text'>
            © {year} RED.DEV. INC. All Rights Reserved.
          </span>
          <div className='footer__pwb'>
            <div className='footer__pwb-inner'>
              <div className='footer__pwb-avalanche'>
                <img className='front' src={pwa} alt='pwa' />
              </div>
              <div className='footer__pwb-reddev'>
                <img className='back' src={pwr} alt='pwr' />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='mobile-footer'>
        <div className='footer-group1'>
          <div className='mobile-footer__social-icons'>
            {/* <a href='https://www.facebook.com/reddevinc/' target='_blank'><img className="footer__social-icon social-icon1" src={fb} alt="fb"></img></a> */}
            <a
              href='https://x.com/fundraisinapp'
              target='_blank'
              rel='noreferrer'
            >
              <img
                className='footer__social-icon social-icon2'
                src={x}
                alt='x'
              ></img>
            </a>
            {/* <a href='https://www.linkedin.com/company/reddevinc' target='_blank'><img className="footer__social-icon social-icon3" src={linkedin} alt="linkedin"></img></a> */}
            <a
              href='https://arena.social/fundraisinapp'
              target='_blank'
              rel='noreferrer'
            >
              <img
                className='footer__social-icon social-icon4'
                src={arenas}
                alt='arenas'
              ></img>
            </a>
            <a
              href='hhttps://instagram.com/fundraisin.app'
              target='_blank'
              rel='noreferrer'
            >
              <img
                className='footer__social-icon social-icon4'
                src={instagram}
                alt='instagram'
              ></img>
            </a>
            <span className='footer-vertical-line'></span>
            <a
              href='/tos'
              target='_blank'
              rel='noreferrer'
              className='footer-tos-text'
            >
              Terms of Service
            </a>
          </div>

          <div className='footer__pwb'>
            <div className='footer__pwb-inner'>
              <div className='footer__pwb-avalanche'>
                <img className='front' src={pwa} alt='pwa' />
              </div>
              <div className='footer__pwb-reddev'>
                <img className='back' src={pwr} alt='pwr' />
              </div>
            </div>
          </div>
        </div>
        <span className='footer__copyright-text'>
          © {year} RED.DEV. INC. All Rights Reserved.
        </span>
      </div>
    </footer>
  );
};

export default Footer;
